// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oAc7l","placeholdersHeader":"styles_placeholdersHeader__10NcQ","editorStyle":"styles_editorStyle___dG0A","placeholdersBox":"styles_placeholdersBox__1wyFp"};